import { render } from "./AppCanvasCollage.vue?vue&type=template&id=56d0d0a4&scoped=true&ts=true"
import script from "./AppCanvasCollage.vue?vue&type=script&lang=ts"
export * from "./AppCanvasCollage.vue?vue&type=script&lang=ts"

import "./AppCanvasCollage.vue?vue&type=style&index=0&id=56d0d0a4&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56d0d0a4"]])

export default __exports__